import { Component } from '@angular/core';
import {GenericButtonComponent} from "../generic-button/generic-button.component";
import {StorageService} from "../../services/storage.service";

@Component({
  selector: 'debug-setter',
  standalone: true,
  imports: [
    GenericButtonComponent
  ],
  templateUrl: './debug-setter.component.html',
})
export class DebugSetterComponent extends GenericButtonComponent {

  constructor() {
    super()
  }

  changeDebugMode(): void {
    if (!this.disabled) {
      StorageService.sharedInstance.setItemJson('srs.debug', !this.debug)
    }
  }
}

